import { apiUrl } from "@/api/api";
import { PersonaImageAvatar } from "./PersonaImageAvatar";
import { Persona } from "@/api/personas";
import { Card, CardContent } from "@/components/ui/card";

const PersonaCards = ({
  personas,
  onSelectPersona,
}: {
  personas: Persona[];
  onSelectPersona: (personaId: string) => void;
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
      {personas
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((persona) => (
          <Card
            key={persona.persona_id}
            onClick={() => onSelectPersona(persona.persona_id)}
          >
            <CardContent className="px-4 py-2 flex flex-col items-center">
              <PersonaImageAvatar
                className="w-16 h-16 border border-2 border-[#D1FA64] rounded-full"
                src={
                  persona.avatar_id !== ""
                    ? `${apiUrl}/get-file?url=persona-knowledge-base/${persona.persona_id}/${persona.avatar_id}`
                    : undefined
                }
                altText={persona.name || "Avatar"}
                gender={persona.gender}
              />
              <span className="text-center">{persona.name}</span>
            </CardContent>
          </Card>
        ))}
    </div>
  );
};

export default PersonaCards;
